module.exports = __webpack_public_path__ + "assetlinks.json";